// The workspace claim the Engine list and import routes read as `?workspace=`. A person with one
// workspace sends nothing (the server selects it); a person with several sends the one chosen in the switcher.
const ID = /^[A-Za-z0-9_-]{1,120}$/

export const validWorkspaceId = value => typeof value === 'string' && ID.test(value)

// `workspaceId` is null or undefined for "send nothing"; anything else must be a plain workspace id.
export function normalizeWorkspace(workspaceId) {
  if (workspaceId === null || workspaceId === undefined) return null
  if (!validWorkspaceId(workspaceId)) throw new TypeError('The workspace is invalid.')
  return workspaceId
}

export const withWorkspace = (path, workspaceId) => (workspaceId ? `${path}?workspace=${encodeURIComponent(workspaceId)}` : path)
